"use client";

import { useMemo } from "react";

import { filterableDocumentCategoryOptions } from "@/type-labels";
import useFeatureFlag from "./featureFlag";

/**
 * The category options for the portal document filters that offer the whole
 * `DocumentCategory` enum — the cross-entity documents view and the holding
 * documents tab.
 *
 * One hook rather than `useFeatureFlag` at both call sites, so the flag that
 * withholds `CORPORATE_ACTIONS` cannot be wired up on one filter and forgotten
 * on the other. Mirrors admin-app's
 * `useSelectableInvestingEntityDocumentCategoryLabels`.
 *
 * The single-entity documents filter deliberately does not use this: it builds
 * its options from the categories present in the API response, so it already
 * offers a category only once the account holds a document in it.
 *
 * Note this reads the client-side flag, which in the e2e suite comes from the
 * mocked `features` query rather than the `CYPRESS_FEATURE_FLAGS` cookie — a spec
 * asserting on these options has to mock the query.
 */
export function useDocumentCategoryFilterOptions() {
	const isFormsModuleEnabled = useFeatureFlag("FORMS_MODULE");

	return useMemo(
		() => filterableDocumentCategoryOptions({ isFormsModuleEnabled }),
		[isFormsModuleEnabled],
	);
}
